import { render, staticRenderFns } from "./ObjectsEdit.vue?vue&type=template&id=082ccdf5&"
import script from "./ObjectsEdit.vue?vue&type=script&lang=js&"
export * from "./ObjectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports